import React from 'react';
import { Typography, Divider } from 'antd';
import { dateFromString } from '../../../utils/dateFromString';

const { Text } = Typography;

export default function HistorialReembolso({ historial }) {
  return (
    <div style={{ fontSize: '11px', display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {historial?.slice().reverse().map((item, index) => (
            <div key={index}>
              <div style={{ paddingBottom: 6, lineHeight: 1.4 }}>
                <Text type="secondary" style={{ fontSize: '10px', display: 'block', marginBottom: 2 }}>
                  {dateFromString(item.fecha)?.f1 || item.fecha} | {item.usuarioNombre}
                </Text>
                <Text style={{ fontSize: '11px', display: 'block', whiteSpace: 'pre-line' }}>
                  {item.comentario}
                </Text>
              </div>
              {index !== historial.length - 1 && <Divider style={{ margin: '6px 0' }} />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
